/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {validityCalculation} from './coupon-commons';
import {CouponResource} from '../../../components/api/resources/resource/coupon.resource';

@Component({
  standalone: false,
  selector: 'adn-coupon-route-page',
  template: `
    <adn-coupon-list-page
      *ngIf="list"
      [list]="list">
    </adn-coupon-list-page>
  `
})
export class CouponRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(CouponResource) private readonly Coupon: any
  ) {
  }

  ngOnInit(): void {
    this.adnListHelper.setUpList(this.list, this.Coupon, false, 'fullCouponList', {
      baseTable: 'coupon',
      afterFill: (items: any[]) => {
        items.forEach((item: any) => {
          validityCalculation(item);
        });
      }
    });
  }
}
